export const ScrollOffsets = {
  componentsPage: 0,
  resultsPage: 0,
};
